import React, { Component,useRef } from 'react'
import { browserHistory } from 'react-router'
import { connect } from 'react-redux'
import { Field, reduxForm, SubmissionError, getFormValues, change } from 'redux-form'
import { PulseLoader } from 'halogen'
import { appendToFormData } from '../../helpers/utility'
import api from '../../api/api'
import { Row, Grid, Form, Button, FormGroup, InputGroup } from '@sketchpixy/rubix'
import {
  SIGNUP_REQUEST,
  FETCH_STATES_REQUEST,
  FETCH_DISTRICTS_REQUEST,
  FETCH_GRADES_REQUEST,
} from '../../actions/actions'
import * as MabnaButton from '../common/Button/Button'
import { genericRadioButtonGroup } from '../common/FormFields/Fields';

const styles = {
  spinner: {
    height: 45,
    display: 'flex',
    alignContent: 'center',
    alignItems: 'center',
  },
  formWrapperStyles: {
    padding: 25,
    paddingTop: 0,
    paddingBottom: 0,
    margin: 'auto',
    marginBottom: 25,
    marginTop: 25,
  },
}

const nationalityOptions = [
  { title: 'ایرانی', id: 'iran' },
  { title: 'غیر ایرانی', id: 'other' },
]

const changeFieldValue = (field, val) => change('studentSignup', field, val)

class StudentSignup extends Component {
  constructor(props) {
    super(props)

    this.state = {
      districts: [],
      schools: [],
      
      loadingDistricts: false,
      loadingSchools: false,
    }
  }

  componentDidMount() {

    this.props.dispatch({
      type: FETCH_STATES_REQUEST,
    })

    this.props.dispatch({
      type: FETCH_GRADES_REQUEST,
    })
  }

  isNotDefaultValue = value => value && value !== -1 && value !== '-1'

  componentWillUpdate(nextProps, nextState) {
    // this.updateSchoolsIfNeeded(nextProps)
    this.updateDistrictsIfNeeded(nextProps)
  }

  // updateSchoolsIfNeeded(nextProps) {
  //   const { formValues: nextFormValues = {} } = nextProps
  //   const { gender, district, state, grade } = nextFormValues

  //   const shouldCare =
  //     this.isNotDefaultValue(gender) &&
  //     this.isNotDefaultValue(state) &&
  //     this.isNotDefaultValue(district) &&
  //     this.isNotDefaultValue(grade)

  //   if (shouldCare) {
  //     const { formValues: currentFormValues = {} } = this.props

  //     const itAffectsSchoolsList =
  //       gender !== currentFormValues.gender ||
  //       state !== currentFormValues.state ||
  //       district !== currentFormValues.district ||
  //       grade !== currentFormValues.grade

  //     if (itAffectsSchoolsList) {
  //       this.updateSchools({ state, district, gender, grade })
  //     }
  //   }
  // }

  updateDistrictsIfNeeded(nextProps) {
    const { formValues: nextFormValues = {} } = nextProps

    if (this.isNotDefaultValue(nextFormValues.state)) {
      const { formValues: currentFormValues = {} } = this.props

      if (nextFormValues.state !== currentFormValues.state) {
        this.updateDistricts(nextFormValues.state)
      }
    }
  }

  updateDistricts = stateId => {
    this.setState({ loadingDistricts: true })

    // reset city value for better ux
    this.props.dispatch(changeFieldValue('district', -1))

    new Promise((resolve, reject) => {
      this.props.dispatch({
        type: FETCH_DISTRICTS_REQUEST,
        stateId,
        resolve,
        reject,
      })
    })
      .then(districts => {
        this.setState({
          isLoadingDistricts: false,
          districtPlaceholder : '(ابتدا استان را انتخاب کنید)',
          districts: districts,
        })
        this.props.dispatch(changeFieldValue('district', -1))
        // this.props.dispatch(changeField('district', -1))
        // inputRef.current.placeholder = '(ابتدا استان را انتخاب کنید)'
      })
      .catch(err => {
        this.setState({ isLoadingDistricts: false })
        // this.props.dispatch(changeFieldValue('district', -1))
        // inputRef.current.placeholder = 'منطقه ای یافت نشد'

        console.log(err)
      })
  }
  

  
  // updateSchools = data => {
  //   this.setState({ loadingSchools: true })

  //   api
  //     .fetchSchools(data)
  //     .then(res => {
  //       const formattedData = res.data.data.schools.map(school => ({
  //         id: school.id,
  //         name: school.school_name,
  //         value: school.id,
  //         school_source: school.school_source
  //       }))

  //       this.setState({ loadingSchools: false, schools: formattedData })
  //     })
  //     .catch(err => {
  //       this.setState({ loadingSchools: false })
  //     })
  // }

  getStateNameById = stateId => {
    const state = this.props.states.find(state => state.id === parseInt(stateId, 10))
    return state ? state.name : null
  }

  passwordInput = ({ input, meta: { touched, error }, ...custom }) => {
    let hasError = touched && error !== undefined
    return (
      <FormGroup controlId="password">
        <div className="form-error">{hasError && error}</div>
        <InputGroup bsSize="large">
          <InputGroup.Addon>
            <i className="fa fa-key" aria-hidden="true" />
          </InputGroup.Addon>
          <input
            type="password"
            className="border-focus-blue"
            placeholder="گذرواژه (اعداد و حروف)"
            {...input}
            {...custom}
          />
        </InputGroup>
      </FormGroup>
    )
  }

  confirmPasswordInput = ({ input, meta: { touched, error }, ...custom }) => {
    let hasError = touched && error !== undefined
    return (
      <FormGroup controlId="confirmPassword">
        <div className="form-error">{hasError && error}</div>
        <InputGroup bsSize="large">
          <InputGroup.Addon>
            <i className="fa fa-key" aria-hidden="true" />
          </InputGroup.Addon>
          <input
            type="password"
            className="border-focus-blue"
            placeholder="تایید گذرواژه"
            {...input}
            {...custom}
          />
        </InputGroup>
      </FormGroup>
    )
  }

  firstName = ({ input, meta: { touched, error }, ...custom }) => {
    let hasError = touched && error !== undefined
    return (
      <FormGroup controlId="firstName">
        <div className="form-error">{hasError && error}</div>
        <InputGroup bsSize="large">
          <InputGroup.Addon>
            <i className="fa fa-address-card" aria-hidden="true" />
          </InputGroup.Addon>
          <input
            type="text"
            className="border-focus-blue"
            placeholder="نام"
            {...input}
            {...custom}
          />
        </InputGroup>
      </FormGroup>
    )
  }

  lastName = ({ input, meta: { touched, error }, ...custom }) => {
    let hasError = touched && error !== undefined
    return (
      <FormGroup controlId="lastName">
        <div className="form-error">{hasError && error}</div>
        <InputGroup bsSize="large">
          <InputGroup.Addon>
            <i className="fa fa-address-card" aria-hidden="true" />
          </InputGroup.Addon>
          <input
            type="text"
            className="border-focus-blue"
            placeholder="نام خانوادگی"
            {...input}
            {...custom}
          />
        </InputGroup>
      </FormGroup>
    )
  }

  email = ({ input, meta: { touched, error }, ...custom }) => {
    let hasError = touched && error !== undefined
    return (
      <FormGroup controlId="email">
        <div className="form-error">{hasError && error}</div>
        <InputGroup bsSize="large">
          <InputGroup.Addon>
            <i className="fa fa-envelope" aria-hidden="true" />
          </InputGroup.Addon>
          <input
            type="email"
            className="border-focus-blue"
            placeholder="ایمیل"
            {...input}
            {...custom}
          />
        </InputGroup>
      </FormGroup>
    )
  }

  mobile = ({ input, meta: { touched, error }, ...custom }) => {
    let hasError = touched && error !== undefined
    return (
      <FormGroup controlId="mobile">
        <div className="form-error">{hasError && error}</div>
        <InputGroup bsSize="large">
          <InputGroup.Addon>
            <i className="fa fa-mobile" aria-hidden="true" />
          </InputGroup.Addon>
          <input
            type="text"
            className="border-focus-blue"
            placeholder="شماره تلفن همراه"
            {...input}
            {...custom}
          />
        </InputGroup>
      </FormGroup>
    )
  }

  secondPhone = ({ input, meta: { touched, error }, ...custom }) => {
    let hasError = touched && error !== undefined
    return (
      <FormGroup controlId="secondPhone">
        <div className="form-error">{hasError && error}</div>
        <InputGroup bsSize="large">
          <InputGroup.Addon>
            <i className="fa fa-phone" aria-hidden="true" />
          </InputGroup.Addon>
          <input
            type="text"
            className="border-focus-blue"
            placeholder="شماره تماس دوم"
            {...input}
            {...custom}
          />
        </InputGroup>
      </FormGroup>
    )
  }

  nationalNumber = ({ input, meta: { touched, error }, ...custom }) => {
    let hasError = touched && error !== undefined
    return (
      <FormGroup controlId="nationalNumber">
        <div className="form-error">{hasError && error}</div>
        <InputGroup bsSize="large">
          <InputGroup.Addon>
            <i className="fa fa-id-card-o" aria-hidden="true" />
          </InputGroup.Addon>
          <input
            type="text"
            className="border-focus-blue ltr"
            placeholder='کد ملی یا شماره گذرنامه'
            // placeholder= document.title == '' ? "شماره ملی (این شماره نام کاربری شما خواهد بود)" : "شماره گذرنامه (این شماره نام کاربری شما خواهد بود)"; 
            {...input}
            {...custom}
          />
        </InputGroup>
      </FormGroup>
    )
  }

  address = ({ input, meta: { touched, error }, ...custom }) => {
    let hasError = touched && error !== undefined
    return (
      <FormGroup controlId="address">
        <div className="form-error">{hasError && error}</div>
        <InputGroup bsSize="large">
          <InputGroup.Addon>
            <i className="fa fa-map-marker" aria-hidden="true" />
          </InputGroup.Addon>
          <textarea
            type="text"
            className="border-focus-blue"
            placeholder="نشانی"
            {...input}
            {...custom}
          />
        </InputGroup>
      </FormGroup>
    )
  }

  selectInputCreator = settings => ({
    input,
    meta: { touched, error },
    options,
    iconClassName,
    hint,
  }) => {
    const hasError = touched && error
    const placeholder = settings.loading ? ' منطقه را انتخاب کنید'  : settings.placeholder

    return (
      <FormGroup controlId="address">
        {hint && <div className="form-warning">{hint}</div>}

        <div className="form-error">{hasError && error}</div>

        <InputGroup bsSize="large">
          <InputGroup.Addon>
            <i className={`fa ${iconClassName || 'fa-pencil'}`} aria-hidden="true" />
          </InputGroup.Addon>

          <select {...input} disabled={settings.disabled}>
            <option value={-1} hidden disabled>{placeholder}</option>

            {options.map(option => (
              <option key={option.id} value={option.id}>
                {option.name}
              </option>
            ))}
          </select>
        </InputGroup>
      </FormGroup>
    )
  }

  // renderAutoComplete = ({
  //   input,
  //   meta: { touched, error, warning },
  //   options,
  //   disabled,
  //   loading,
  //   iconClassName
  // }) => {
  //   const hasError = Boolean(touched && error)

  //   const handleSchoolTextChange = school_name => {
  //     input.onChange(school_name)
  //     this.updateSchools({ school_name, ...this.getCurrentFormValues() })
  //   }

  //   const placeholder = loading ? 'در حال بارگذاری' : 'مدرسه'

  //   const warningMessage =
  //     'لطفا مدرسه خود را از لیست پیشنهادی انتخاب و یا جستجو نمایید (ابتدا فیلدهای بالا را تکمیل کنید).'

  //   const secondWarningMessage =
  //     'درصورتی که مدرسه شما در لیست وجود ندارد ابتدا به مسئولین مدرسه خود مراجعه کرده و پس از عضویت مدرسه در سامانه، اقدام به عضویت نمایید'

  //   return (
  //     <FormGroup controlId="address">
  //       <div className="form-warning">{warningMessage}</div>
  //       <div className="form-warning">{secondWarningMessage}</div>
  //       <div className="form-error">{hasError && error}</div>
  //       <InputGroup bsSize="large">
  //         <InputGroup.Addon>
  //           <i className={`fa ${iconClassName || 'fa-pencil'}`} aria-hidden="true" />
  //         </InputGroup.Addon>
  //         <AutoCompleteInput
  //           {...input}
  //           disabled={disabled}
  //           placeholder={placeholder}
  //           options={options}
  //           onTextChange={handleSchoolTextChange}
  //         />
  //       </InputGroup>
  //     </FormGroup>
  //   )
  // }

  onSubmit = values => {
    // school field is an object with some fields like:‌ 'id', 'school_source'
    // const schoolData = {
    //   school_id: values.school ? values.school.id : null,
    //   school_source: values.school ? values.school.school_source : null
    // }

    // school field itself must be removed before submit

    const schoolData = {
      school_id: null,
      school_source: null,
    }

    const data = Object.assign({}, values, schoolData, { school: undefined })
    let formData = appendToFormData(data)

    return new Promise((resolve, reject) => {
      this.props.dispatch({
        type: SIGNUP_REQUEST,
        formData,
        resolve,
        reject,
        userType: 'STUDENT',
      })
    })
      .then(() => this.redirect())
      .catch(response => {
        throw new SubmissionError({
          _error: response.general_errors[0],
          ...response.form_errors,
        })
      })
  }

  redirect = () => browserHistory.push('/signup/success')

  genderOptions = [{ id: 'female', name: 'دختر' }, { id: 'male', name: 'پسر' }]
  getCurrentFormValues = () => this.props.formValues || {}

  isSchoolFieldDisabled = () => {
    const { gender, state, district, grade } = this.getCurrentFormValues()

    if (gender && district && state && grade) {
      return false
    } else {
      return true
    }
  }

  render() {
    const { handleSubmit, error, formValues = {} } = this.props
    const { states } = formValues
    const districtPlaceholder = `منطقه (ابتدا استان را انتخاب کنید)`

    // const [districtPlaceholder, setPlaceholder] = useState(`منطقه ${state ? '' : '(ابتدا استان را انتخاب کنید)'}`);


    return (
      <div>
        <div style={styles.formWrapperStyles}>
          <Form onSubmit={handleSubmit(this.onSubmit)}>
            {/*<Field name="username" component={this.usernameInput} />*/}
            <Field name="first_name" component={this.firstName} />

            <Field name="last_name" component={this.lastName} />

            <Field
              name="nationality"
              title="تابعیت"
              component={genericRadioButtonGroup}
              options={nationalityOptions}
              className='horizontal-options rtl'
            />

            <Field
              name="national_number"
              component={this.nationalNumber}
              autoComplete="username"
            />

            <Field
              name="gender"
              component={this.selectInputCreator({
                placeholder: 'جنسیت',
              })}
              options={this.genderOptions}
              iconClassName="fa-genderless"
            />

            <Field name="phone_number" component={this.mobile} />

            {/* <Field name="email" component={this.email} /> */}
            <Field
              name="grade"
              component={this.selectInputCreator({
                placeholder: 'پایه تحصیلی',
              })}
              options={this.props.grades}
            />
            {/* 

            
//------------------------------------Here----------------------

           */}
           <Field
              name="state"
              component={this.selectInputCreator({
                placeholder: 'استان',
              })}
              options={this.props.states}
              iconClassName="fa-map-marker"
            />
 <Field
              name="district"
              component={this.selectInputCreator({
                placeholder: districtPlaceholder,
                disabled: this.state.districts.length === 0,
                loading: this.state.loadingDistricts,
              })}
              options={this.state.districts}
              iconClassName="fa-map-marker"
              // hint="در صورتی که منطقه مدرسه خود را نمی دانید از مسئولین مدرسه راهنمایی بگیرید."
            /> 
            {/* <Field
              name="school"
              component={this.renderAutoComplete}
              options={this.state.schools}
              disabled={this.isSchoolFieldDisabled()}
              loading={this.state.loadingSchools}
              iconClassName="fa-book"
            /> */}
{//------------------------------------Here----------------------
  }
            <Field name="address" component={this.address} />

            {/*<Field name="secondary_phone" component={this.secondPhone} />*/}

            <Field
              name="password"
              component={this.passwordInput}
              autoComplete="password"
            />

            <Field name="confirm_password" component={this.confirmPasswordInput} />

            <FormGroup>
              <Grid>
                <Row style={{ textAlign: 'center', padding: '5px' }}>
                  {error && <strong>{error}</strong>}
                </Row>

                <Row>
                  <div className="auth-buttons-container">
                    {!this.props.aSyncCall ? (
                      <MabnaButton.Primary buttonSize='large' type="submit" className="">
                        عضویت
                      </MabnaButton.Primary>
                    ) : (
                      <div style={styles.spinner}>
                        <PulseLoader color="#275C8A" size="10px" />
                      </div>
                    )}

                    <MabnaButton.Primary
                      buttonSize='large'
                      outline
                      className=""
                      onClick={() => browserHistory.push('/')}
                    >
                      بازگشت
                    </MabnaButton.Primary>
                  </div>
                </Row>
              </Grid>
            </FormGroup>
          </Form>
        </div>
      </div>
    )
  }
}

const validate = values => {
  let errors = {}

  if (parseInt(values.grade, 10) === 0) {
    errors.grade = 'انتخاب مقطع تحصیلی الزامی است'
  }

  if (!values.last_name) {
    errors.last_name = 'نام خانوادگی الزامی است'
  }

  if (!values.first_name) {
    errors.first_name = 'نام الزامی است'
  }

  // if (!values.email) {
  //   errors.email = 'ایمیل الزامی است'
  // }

  if (!values.national_number) {
    errors.national_number = 'شماره ملی یا شماره گذرنامه الزامی است'
  }

  if (!values.phone_number) {
    errors.phone_number = 'شماره تلفن همراه الزامی است'
  }

  if (!values.password) {
    errors.password = 'گذرواژه الزامی است'
  }

  if (values.password !== values.confirm_password || !values.password) {
    errors.confirm_password = 'گذرواژه و تایید آن یکسان نیست'
  }

  if (!values.gender || values.gender === -1 || values.gender === '-1') {
    errors.gender = 'جنسیت الزامی است'
  }

  if(!values.nationality) {
    errors.nationality = 'تابعیت الزامی است'
  }

  if (!values.state || values.state === -1 || values.state === '-1') {
    errors.state = 'استان الزامی است'
  }

//------------------------------------Here----------------------
  if (!values.district || values.district === -1 || values.district === '-1') {
    errors.district = 'منطقه الزامی است'
  }
  // if (!values.city || values.city === -1 || values.city === '-1') {
  //   errors.city = 'شهر الزامی است'
  // }

  // if (!values.school || values.school === -1 || values.school === '-1') {
  //   errors.school = 'انتخاب مدرسه دانش آموز الزامی است'
  // }

    if (!values.address) {
    errors.address = 'آدرس  دانش آموز الزامی است'
  }
  // if (!values.school) {
  //   errors.school = 'انتخاب مدرسه دانش آموز الزامی است'
  // }

  //------------------------------------Here----------------------
if (!values.grade || values.grade === -1 || values.grade === '-1') {
    errors.grade = 'انتخاب پایه تحصیلی دانش آموز الزامی است'
  }

  return errors
}

StudentSignup = reduxForm({
  form: 'studentSignup',
  validate,
})(StudentSignup)

const mapStateToProps = state => ({
  states: state.states,
  grades: state.grades,
  // districtPlaceholder : `منطقه ${state ? '' : '(ابتدا استان را انتخاب کنید)'}`,

  formValues: getFormValues('studentSignup')(state),
  initialValues: {
    gender: -1,
    state : -1,
    grade : -1,
    district: -1,
    

  }
})

export default connect(mapStateToProps)(StudentSignup)



// WEBPACK FOOTER //
// ./src/components/student/StudentSignup.js